// This file is auto-generated by dibs-icons script
import { type FC } from 'react';
import QuestionMark20 from './QuestionMark20.tsx';
import QuestionMark20Circle from './QuestionMark20Circle.tsx';
import QuestionMark24 from './QuestionMark24.tsx';
import QuestionMark24Circle from './QuestionMark24Circle.tsx';
import QuestionMark40 from './QuestionMark40.tsx';
import QuestionMark48 from './QuestionMark48.tsx';

type QuestionMarkProps = {
    variation: '20' | '20Circle' | '24' | '24Circle' | '40' | '48';
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const svgVariations = {
    QuestionMark20,
    QuestionMark20Circle,
    QuestionMark24,
    QuestionMark24Circle,
    QuestionMark40,
    QuestionMark48,
};

const QuestionMark: FC<QuestionMarkProps> = ({ variation, ...props }) => {
    const variationKey = `QuestionMark${variation}` as keyof typeof svgVariations;
    const Icon = svgVariations[variationKey];

    if (!Icon) {
        // eslint-disable-next-line no-console
        console.error(`"QuestionMark" icon variation ${variationKey} does not exist`);
        return null;
    }

    return <Icon {...props} />;
};

export default QuestionMark;
